module.exports = __webpack_public_path__ + "static/media/check.9658d5e2.png";